// import { useEffect } from "react";

import { network } from '../network';
import { auth } from '../auth';

const apiUrl = process.env.BOND_SPORTS_API_URL;

// interface userLogin{
//     username: string;
//     password: string;
// }

async function login(username: string, password: string) {
	const data = { email: username, password: password };

	const response = await network.post(`${apiUrl}auth/login`, data);

	// When fetch succeeds
	// save token to local storage
	auth.setToken(response.token);
	auth.setUserId(response.user.id);

	return response;
}

function isLogin() {
	return Boolean(auth.getToken()) && Boolean(auth.getUserId());
}

function logout() {
	auth.removeToken();
	auth.removeUserId();
}

async function getUserData() {
	const options = auth.getAuthHeaders();
	const userId = auth.getUserId();

	if (!userId) {
		return false;
	}

	await network
		.get(`${apiUrl}/v1/users/${userId}/settings`, options)
		.catch(error => {
			// When fetch ends with a bad HTTP status, e.g. 404
			return error.message;
		})
		.then(response => {
			// When fetch succeeds

			return response;
		});
}

async function resetPassword(password: string, passwordRepeat: string, token: string) {
	const data = {
		password: password,
		passwordRepeat: passwordRepeat,
		token: token,
	};

	const response = await network.post(`${apiUrl}auth/password-reset`, data);

	return response;
}

// async function getQuestions(facilityId: string){

//   const userToken = auth.getToken();

//   const data = {
//     'headers': {
//       'accept': 'application/json, text/plain, */*',
//       'authorization': `Bearer ${userToken}`
//     }
//   }

// return network.get(`${apiUrl}/v1/venues/${facilityId}/questionnaire`,data);

// }

// function loggedIn(){
//     // Checks if there is a saved token and it's still valid
//     const token = auth.getAuth()
//     return !!token && !isTokenExpired(token) // handwaiving here
// }

// // reserveation
// authApi.login('yossi+1@bondsports.co', '123456');
// // authApi.logout();
// const test = authApi.isLogin();

export const authApi = {
	login,
	logout,
	isLogin,
	getUserData,
	resetPassword,
	// getQuestions,
};
